import Head from "next/head";
import Navbar from "../../components/general/Navbar";
import Header from "../../components/general/Header";
import HiddenMenu from "../../components/general/HiddenMenu";
import Footer from "../../components/general/Footer";
import LoginForm from "../../components/form/LoginForm";
import { useState, useEffect } from "react";
import AuthServices from "../../services/Auth.services";
import Link from "next/link";
const Cryptr = require('cryptr');

export default function Index({navigation, loggedIn, jwtToken, credentials }) {
  const [auth, setAuth] = useState(loggedIn);
  const [userInfo, setUserInfo] = useState();

  useEffect(() => {
    if (!jwtToken) {
      return;
    }
    setUserInfo(AuthServices.getUserData(jwtToken));
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Head>
        <title>Olaf Nijenkamp | Inloggen</title>
        <meta name="description" content="Generated by create next app" />
      </Head>

      <header>
        <Navbar items={navigation} />
        <HiddenMenu role={userInfo?.role} />
        <Header title="Log in" small={true} />
      </header>

      <main className="mb-auto">
        <section className="mt-16">
          <div className="olafGrid lg:max-w-lg">
            <LoginForm creds={credentials} />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export async function getServerSideProps(context) {
  var loggedIn = context.req.cookies["auth"] ? true : false;
  if (!loggedIn) {
    const token = context.req.cookies["session_token"]

    const creds = await fetch(
        process.env.NEXT_PUBLIC_CRAFT_BASE_URL +
        "/api/sessions/get?token=" + token,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
    ).then((response) => response.json());

    const cryptr = new Cryptr('TM7Q587K56eaBCCB2HeZ');
    let res = null;
    try {
      res = {
        "username": cryptr.decrypt(creds.username),
        "password": cryptr.decrypt(creds.password)
      }
    } catch (e) {

    }

    return {
      props: {
        loggedIn: false,
        jwtToken: null,
        credentials: res || null,
      }, // will be passed to the page component as props
    };
  }

  if (loggedIn) {
    return {
      redirect: {
        destination: "/dashboard",
        permanent: false,
      },
    };
  }
  const jwtToken = context.req.cookies["auth"];

  AuthServices.cookieCheck(jwtToken, context);
  await AuthServices.refreshToken(jwtToken, context);

  return {
    props: {
      loggedIn: loggedIn,
      jwtToken: jwtToken || null,
    }, // will be passed to the page component as props
  };
}
